import { registerComponent } from '../app'
import Scroll from '../services/Scroll'

const ScrollBarPad = (scope, el) => {
	scope.start(() => {
		el.style.paddingRight = Scroll.scrollBarWidth() + 'px'
	})
}

registerComponent('scroll-bar-pad', ScrollBarPad)
